import * as React from "react";

import DataContext from "../common/DataContext";

import { DataContextType } from "../common/DataContext";
import { UserGetMyselfResponseType } from "../api/responses/userResponseTypes";

import {
  UserType,
  RoleType,
  GroupType,
  PolicyType,
  AttributeMetadataType,
  ScopeType
} from "../api/types";

import * as UserApi from "../api/fetchers/users";
import * as RoleApi from "../api/fetchers/roles";
import * as GroupApi from "../api/fetchers/groups";
import * as PolicyApi from "../api/fetchers/policies";
import * as AttributeMetadataApi from "../api/fetchers/attribute-metadata";
import * as ScopeApi from "../api/fetchers/scopes";

type PropsType = React.PropsWithChildren & {};

export default function DataProvider(props: PropsType) {
  const [users, setUsers] = React.useState<UserType[]>([]);
  const [roles, setRoles] = React.useState<RoleType[]>([]);
  const [myself, setMyself] = React.useState<UserGetMyselfResponseType>();
  const [groups, setGroups] = React.useState<GroupType[]>([]);
  const [policies, setPolicies] = React.useState<PolicyType[]>([]);
  const [scopes, setScopes] = React.useState<ScopeType[]>([]);

  const [attributeMetadatas, setAttributeMetadatas] = React.useState<
    AttributeMetadataType[]
  >([]);

  async function fetchUsers() {
    const response = await UserApi.getAll();

    if (response) {
      setUsers(response.users);
    } else {
      setUsers([]);
    }
  }

  async function fetchRoles() {
    const response = await RoleApi.getAll();

    if (response) {
      setRoles(response.roles);
    } else {
      setRoles([]);
    }
  }

  async function fetchMyself() {
    const response = await UserApi.getMyself();
    if (response) {
      setMyself(response);
    }
  }

  async function fetchGroups() {
    const response = await GroupApi.getAll();

    if (response) {
      setGroups(response.groups);
    } else {
      setGroups([]);
    }
  }

  async function fetchPolicies() {
    const response = await PolicyApi.getAll();

    if (response) {
      setPolicies(response.policies);
    } else {
      setPolicies([]);
    }
  }

  async function fetchAttributeMetadatas() {
    const response = await AttributeMetadataApi.getAll();

    if (response) {
      setAttributeMetadatas(response.attributeMetadatas);
    } else {
      setAttributeMetadatas([]);
    }
  }

  async function fetchScopes() {
    const response = await ScopeApi.getAll();

    if (response) {
      setScopes(response.scopes);
    } else {
      setScopes([]);
    }
  }

  const initialValue: DataContextType = {
    users,
    roles,
    groups,
    myself,
    policies,
    attributeMetadatas,
    scopes,
    fetchUsers,
    fetchRoles,
    fetchMyself,
    fetchGroups,
    fetchPolicies,
    fetchAttributeMetadatas,
    fetchScopes
  };

  return (
    <DataContext.Provider value={initialValue}>
      {props.children}
    </DataContext.Provider>
  );
}
